var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDianyuan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3",
    x: 0.5,
    y: 2.5,
    width: 7,
    height: 12,
    fill: "#D9D9D9",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 4",
    x: 1,
    y: 1,
    width: 6,
    height: 1,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.575 7.05556H15.6615C15.8137 7.05556 15.9101 7.21874 15.8367 7.35203L12.0002 14.3187C11.9004 14.4998 11.625 14.429 11.625 14.2222V9.42222C11.625 9.31177 11.5355 9.22222 11.425 9.22222H9.35499C9.19915 9.22222 9.10318 9.05189 9.18393 8.9186L13.0039 2.61255C13.1088 2.43943 13.375 2.51377 13.375 2.71617V6.85556C13.375 6.96601 13.4645 7.05556 13.575 7.05556Z",
    fill: "#FFE100"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDianyuan);
export default __webpack_public_path__ + "static/media/dianyuan.0991b4feed61e45a074c0110ab98a218.svg";
export { ForwardRef as ReactComponent };